import { isSimpleSelection, isFrame } from '../objects/guards';
import Tool, { type IToolAvailableInput, type IToolActionInput } from './Tool';

class ToolAddSelectionToPresentation extends Tool {
  static toolName = 'Create a presentation from selection';

  static available({ controller, selection }: IToolAvailableInput) {
    if (
      !controller.props.createPresentation ||
      !window.featureFlags.A_17480_whiteboard_presentations
    )
      return false;

    // Available if we have selected at least one frame
    return Boolean(selection?.getObjects().find(obj => isFrame(obj)));
  }

  static action({ controller, selection }: IToolActionInput) {
    const canvas = controller.canvas;

    const selectedFrames = canvas
      .getObjects()
      .reduce((acc: RecordId[], obj: fabric.Object) => {
        if (isFrame(obj)) {
          let isInSelection = false;
          if (isSimpleSelection(selection)) {
            isInSelection = selection.objectInSelection(obj);
          } else {
            isInSelection = obj === selection;
          }

          if (isInSelection) acc.push(obj.id);
        }

        return acc;
      }, []);

    const { createPresentation } = controller.props;

    if (!createPresentation) return;

    createPresentation(selectedFrames)
      .then(payload => {
        window.location.href = `/presentations/${payload.presentation.id}`;
      })
      .catch(err => {
        controller.actionShowMessage({
          message: 'There was an error converting the whiteboard.',
          type: 'error',
        });
        console.error(err);
      });
  }
}

export default ToolAddSelectionToPresentation;
